import Select from 'react-select'
import { useGlobalContext } from '../../utils/Context'
import type { Tag } from './TagChips'

type Props = {
  value: string[]
  onChange: (tagIds: string[]) => void
}

type Option = { value: string; label: string }

/**
 * Multi-select tag filter. Selecting several tags matches shipments carrying
 * ANY of them, the same OR semantics the delivery-type and status filters use.
 *
 * Deleted tags are offered too — shipments tagged before a tag was deleted are
 * still findable by it, and hiding it here would make them unreachable.
 *
 * Styles are inline rather than hoisted so react-select's contextual typing
 * still applies; they mirror the Delivery Type / Status filters beside it.
 */
function TagFilterSelect({ value, onChange }: Props) {
  const { tags } = useGlobalContext()

  const options: Option[] = ((tags as Tag[] | undefined) ?? []).map((tag) => ({
    value: tag._id,
    label: tag.isActive ? tag.name : `${tag.name} (deleted)`,
  }))

  return (
    <Select
      isMulti
      options={options}
      placeholder='Tags'
      value={options.filter((option) => value.includes(option.value))}
      onChange={(selection) => onChange(selection.map((item) => item.value))}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: '#446ce4',
          borderRadius: '32px',
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          fontFamily: 'Poppins',
          fontSize: '12px',
        }),
        multiValue: (baseStyles) => ({
          ...baseStyles,
          background: 'none',
        }),
        multiValueLabel: (baseStyles) => ({
          ...baseStyles,
          fontSize: '12px',
          fontFamily: 'Poppins',
        }),
        option: (baseStyles) => ({
          ...baseStyles,
          fontFamily: 'Poppins',
          fontSize: '12px',
        }),
      }}
    />
  )
}

export default TagFilterSelect
